/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRenditionVideo = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="m19 16-3.5-2v4l3.5-2z" fill="currentcolor" />
      <path
        d="M5 2h12v8h2.404L22 12.504V22H12v-2H5v-4H2V6h3V2zm10 2H7v2h3v10H7v2h5v-8h3V4zM4 14h4V8H4v6zm10-2v8h6v-6.646L18.596 12H14z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgRenditionVideo as RenditionVideo };
